import { motion } from 'framer-motion';
import { classNames } from '~/utils/classNames';

type StatusDotProps = {
  status: 'success' | 'pending' | 'error';
};

const statusConfig = {
  success: {
    bgColor: 'bg-green-500/20',
    dotColor: 'bg-green-500',
  },
  pending: {
    bgColor: 'bg-orange-500/20',
    dotColor: 'bg-orange-500',
  },
  error: {
    bgColor: 'bg-red-500/20',
    dotColor: 'bg-red-500',
  },
};

export const StatusDot = ({ status }: StatusDotProps) => {
  const { bgColor, dotColor } = statusConfig[status];

  return (
    <div className="relative flex items-center justify-center size-4">
      {/* Background circle (fixed size, semi-transparent) */}
      <div className={classNames('absolute rounded-full size-4', bgColor)} />

      {/* Foreground circle (pulsating, solid) */}
      <motion.div
        className={classNames('rounded-full size-2', dotColor)}
        animate={{ scale: [0.8, 1.2, 0.8] }}
        transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
      />
    </div>
  );
};
